export default {
    introduction: {
        img: "https://web-data.zmlearn.com/image/3bxpmZURgNcs3vbR3Qi92c/img_banner_text%402x.png",
    },
    info: {
        title: `<h1>Un  <span> riguroso </span> proceso de selección de Tutores</h1>`,
        button: 'Prueba una clase individual GRATIS',
        bImg: 'https://web-data.zmlearn.com/image/2rBL5G14zz5wUh8oiR9TNL/img_pc_P1%402x.png',
        sImg: 'https://web-data.zmlearn.com/image/ikFzzds4zcs6UT6Fp3rX9i/img_phone_P1%402x.png',
    },
    teach: {
        title: '<h1>Pedagogía-<span>centrada</span> en los alumnos</h1>',
        desc: 'Nuestros tutores son totalmente compasivos y brindan motivación, así como un buen ambiente de aprendizaje.',
    },
    trice: {
        title: `<h1>Siempre <span>flexible</span> y<p>confiable</p></h1>`,
        title1: `<h1>Siempre <span>flexible</span> y<p>&nbsp;confiable</p></h1>`,
        desc: 'Airclass,te garantiza un tutor adecuado y una experiencia de aprendizaje agradable.'
    },
    tutors: {
        title: '<h1><p>Tutores </p> de Airclass</h1>',
        list: [
            {
                id: 1,
                name: 'Ada',
                school: 'Universidad de Cambridge',
                subject: 'Matemáticas',
                experience: '10+ años',
                introduction: `Hola, estoy lista a ayudar a los estudiantes de cualquier manera que pueda. Tengo 10 años de experiencia en tutoría. La educación no es llenar un balde, sino encender un fuego. Estoy muy feliz de adaptar mi plan de lecciones para satisfacer las necesidades del estudiante, por ejemplo, si tiene un área determinada que le gustaría cubrir.`,
                img: 'https://web-data.zmlearn.com/image/tEArepTqxnbSKvxkVR5PBf/img_ada%402x.png',
                evid: ''
            },
            {
                id: 2,
                name: 'Belal',
                school: 'Universidad de Herat',
                subject: 'Programación',
                experience: '9 años',
                introduction: `Soy un desarrollador web experimentado con un historial demostrado de trabajo en la industria del software informático. Habilidad en Python, desarrollo web, ingeniería sólida！ ¡Amo a los niños y disfruto enseñando programación :)!`,
                img: 'https://web-data.zmlearn.com/image/ri6ZpmshdSdyBDoCFWNfgQ/img_belal%402x.png',
                evid: ''
            },
            {
                id: 3,
                name: 'Lupo',
                school: 'Universidad de Londres',
                subject: 'Química',
                experience: '10+ años',
                introduction: `¡Hola! Soy Lupo. Mi objetivo principal con los estudiantes es lograr que trabajen con confianza y eventualmente sean independientes. Será un proceso gradual de retroceder lentamente y permitirles responder las preguntas por sí mismos sin dejar de estar allí en caso de que necesiten un empujón en la dirección correcta.`,
                img: 'https://web-data.zmlearn.com/image/vmyWJyqcLG5JZDfYGYUmVg/img_lupo%402x.png',
                evid: ''
            },
            {
                id: 4,
                name: 'Qhawekazi',
                school: 'Universidad de Fort Hare',
                subject: 'Música',
                experience: '9 años',
                introduction: `Soy músico de profesión y por pasión y recién licenciado en música. Me encanta explorar y aprender nuevas habilidades y animo a mis alumnos a hacer lo mismo; ser creativo y apasionado por la música!`,
                img: 'https://web-data.zmlearn.com/image/cyod2of6PzVcjMjqcErxFE/img_qhawekazi%402x.png',
                evid: ''
            },
            {
                id: 5,
                name: 'Onil',
                school: 'Universidad de los Andes',
                subject: 'Biología',
                experience: '7+ años',
                introduction: `Hola, mi nombre es Onil. Soy un tutor divertido, paciente y agradable. Tengo una variedad de experiencia y puedo proporcionar tutoría en todas las materias básicas. ¡En particular, puedo ayudar en la técnica del examen, el contenido de la materia y el enfoque general para abordar todos sus exámenes!`,
                img: 'https://web-data.zmlearn.com/image/fC7uF1C8QdFofKSfpfwjzm/img_P4_onil%402x.png',
                evid: ''
            },
            {
                id: 6,
                name: 'Judith',
                school: 'Universidad del Noroeste de Potchefstroom',
                subject: 'Ciencias',
                experience: '5 años',
                introduction: `Mi enfoque es ayudar a los estudiantes a dominar su materia, no solo a entenderla. Al hacer esto, nos enfocaremos en las áreas con las que se sienten más incómodos y los animaremos a buscar esas respuestas ellos mismos. También ofrezco sesiones atractivas.`,
                img: 'https://web-data.zmlearn.com/image/eRttjjhZHXW8ueQk3uD45Z/img_judith%402x.png',
                evid: ''
            },
            {
                id: 7,
                name: 'Yi',
                school: 'Academia de Bellas Artes de Macerata',
                subject: 'Artes',
                experience: '3 años',
                introduction: `Obtuve mi licenciatura y maestría en Decoración en la Academia de Bellas Artes de Italia. Considero que un buen docente debe sentir esta singularidad y poseer la capacidad de guiar al alumno hacia una experiencia amena y enriquecedora.`,
                img: 'https://web-data.zmlearn.com/image/fUmCGraib9YPqCb8NFSZpu/img_yi%402x.png',
                evid: ''
            },
            {
                id: 8,
                name: 'Edward',
                school: 'Universidad de Birmingham',
                subject: 'Historia',
                experience: '8 años',
                introduction: `¡Hola, soy Eduardo! Me encanta enseñar, porque me permite compartir mis amores e intereses con los estudiantes, escuchar sus perspectivas y verlos alcanzar sus metas.
                ¡Soy atenta, enfocada, leo bien y me encanta ver a los estudiantes apasionarse por las nuevas ideas!`,
                img: 'https://web-data.zmlearn.com/image/jWbfd5inNjt4urQbvjTLYx/img_edward%402x.png',
                evid: ''
            },
            {
                id: 9,
                name: 'Enrique',
                school: 'Universidad of Nottingham',
                subject: 'Física',
                experience: '3+ años',
                introduction: `Hola, soy Enrique. Mi enfoque principal es darte lecciones que se adapten a ti. Planeo enseñarte conceptos de una manera simple y directa, abordándolos desde diferentes ángulos si es necesario. Luego practicaremos lo que aprendimos a través de las preguntas y exámenes anteriores.`,
                img: 'https://web-data.zmlearn.com/image/vC1DNmRdUJESM5LRz5tDya/img_enirque%402x.png',
                evid: ''
            },
            {
                id: 10,
                name: 'Carol',
                school: 'Universidad Metropolitana Nelson Mandela',
                subject: 'Inglés',
                experience: '10+ años',
                introduction: `Hola, soy Carol y me enorgullece que mis alumnos avancen. No hay una talla que se adapte a todos cuando se trata de una tutoría: cada estudiante tiene diferentes necesidades que deben tenerse en cuenta.`,
                img: 'https://web-data.zmlearn.com/image/uvt2DPn6SXrffhpSbWNULB/img_carol%402x.png',
                evid: ''
            },
            {
                id: 11,
                name: 'Hayk',
                school: 'Universidad Imperial de Londres',
                subject: 'Matemáticas',
                experience: '6 años',
                introduction: `Siempre me han gustado las matemáticas. Y todo lo relacionado con las matemáticas. Llevo dando clases desde hace unos 6 años. Entiendo lo difícil que es aprenderlas y lo útil que es usar técnicas modernas para enseñar.`,
                img: 'https://web-data.zmlearn.com/image/hjehdgD8aE87aY9JRcZVHp/img_hayk%402x.png',
                evid: ''
            },
            {
                id: 12,
                name: 'Rosha',
                school: 'Universidad de Leeds',
                subject: 'Matemáticas',
                experience: '4 años',
                introduction: `Soy Rosha y siempre me han apasionado las Matemáticas y disfruté mucho la materia. Estoy interesado en la importancia de las aplicaciones de las matemáticas, lo que realmente me motivó a seguir estudiando el tema. Realmente espero motivar a mis alumnos de la misma manera, a través de mis lecciones.`,
                img: 'https://web-data.zmlearn.com/image/8LVV9dCUCKb4y9gB1QqHJj/img_rosha%402x.png',
                evid: ''
            },
        ]
    },
    trial: {
        title: '<h1>¿Estás interesado en una clase de <span> prueba  gratuita con </span>  un profesor de Airclass? </h1>'
    }
}